import { Modal, ModalProp } from "../../../components/modal/Modal";
import TableList, { GridCol, GridRow } from "../../../components/table/TableList";
import { Dialog } from "@headlessui/react";
import Button from "../../../components/button/Button";

export type UserIdCardErrorInfoModalProp = {
  col: GridCol[];
  row: GridRow[];
  pdfFlg: boolean;
  usersList: string[];
};

export const UserIdCardErrorInfoModal = ({
  open,
  toggle,
  closeOnClickOutside,
  col,
  row,
  pdfFlg,
  usersList,
}: ModalProp & UserIdCardErrorInfoModalProp) => {
  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <div className="px-2 pb-4 sm:p-4">
          <div className="text-center sm:mt-3">
            <h3 className="text-left text-xl font-semibold leading-6 text-gray-900">
              {pdfFlg? "PDF出力" : "出力詳細"}
            </h3>
            {pdfFlg ? 
              <>
                {usersList.length > 0 ? (
                  <>
                    <h4 className={'text-left text-gray-900 text-ms mt-2'}>　利用者IDカードの出力が完了しました。</h4>
                  </>
                ) : (
                  <>
                    <h4 className={'text-left text-gray-900 text-ms mt-2'}>　出力可能な利用者がいないためPDFの出力ができませんでした。</h4>
                  </>
                )}
              </> : <></>
            }
            <h4 className={'text-left text-red-500 text-ms mt-2'}>　※以下の利用者は利用者IDカードを出力できませんでした。</h4>
            <div className="mt-3">
              <TableList 
                footer={false} 
                gridCol={col} 
                gridRow={row} 
                sort={false}
              />
            </div>
          </div>
        </div>
        <div className="p-4 bg-gray-100">
          <div className="flex justify-end">
            <Button
              className="mx-2 mt-1"
              onClick={toggle}
              children={'閉じる'}
            />
          </div>
        </div>
      </Dialog.Panel>
    </Modal>
  );
}